// ExportVault Landing component
export { default as VaultLanding } from "../Landing";

// Export individual vault components
export { default as AirdropVault } from "./AirdropVault";
export { default as HighGrowthVault } from "./HighGrowthVault";
export { default as StableVault } from "./StableVault";
export { default as CryptaniumVault } from "./CryptaniumVault";

// Export common components
export { default as VaultDWB } from "./Common/VaultDWB";
export { default as Portfolio } from "./Common/Portfolio";
export { default as DefiPartnerships } from "./Common/DefiPartnerships";

// Export the original Airdrop Vault as default for backward compatibility
export { default } from "./AirdropVault";
